export default __webpack_public_path__ + "static/media/shape1.8a740cad.svg";